<template>
  <v-container fluid style="padding: 0px">
    <v-alert 
      v-if="encuestaGuardada == true" 
      type="success">
      Encuesta guardada con éxito.
    </v-alert>
   
    <v-img  v-if="encuestaGuardada == true" 
        :src="require('@/assets/agradecimiento.jpg')"
        alt="logo"
    />

    <v-alert 
      v-else-if="objEncuesta == undefined || objEncuesta.nombreEncuesta == undefined" 
      type="warning">
      Ocurrió un problema al consultar la encuesta. Inténtelo de nuevo más tarde.
     </v-alert>
     <v-card
      v-else
      style="border: 0px; -webkit-box-shadow: none;"
    >
        <v-col v-if="imgPortada != null" cols="12" class="text-center">
          <img v-bind:src="imgPortada" style="max-width:100%; max-height:200px;"></img>    
        </v-col>
      <v-card-title class="headline" color="#0e345b" style="word-break: break-word">
    {{ objEncuesta.nombreEncuesta }}</v-card-title>
      <v-card-subtitle style="word-break: break-word">
      
      <label
                  class="text-justify"
                  v-html="convertirTexto(objEncuesta.objetivo)"
                >
                </label>
      </v-card-subtitle>

      <cat-ins-encuesta 
        v-if="objEncuesta.catalogoInstitucional == true" 
        :is-campus="objEncuesta.campusCatIns"
        :id-campus="objCampusCatIns == null ? null : objCampusCatIns.id"
        :set-campus="setCampus"
        :is-division="objEncuesta.divisionCatIns"
        :id-division="objDivisionCatIns == null ? null : objDivisionCatIns.id" 
        :set-division="setDivision"
        :is-departamento="objEncuesta.departamentoCatIns"  
        :id-departamento="objDepartamentoCatIns == null ? null : objDepartamentoCatIns.id" 
        :set-departamento="setDepartamento"
        :set-value-parametro="setValueParametro" 
        :consulta="consulta" 
        :vista-previa="vistaPrevia"
        :idEncuesta="objEncuesta.idEncuesta"
        :textoCatalogoInstitucional="objEncuesta.textoCatalogoInstitucional">
      </cat-ins-encuesta>
 <cat-dist-encuesta 
        v-if="objEncuesta.catalogoDistribucionTerritorial == true" 
        :is-estado="true"
        :id-estado="objEstadoCatIns == null ? null : objEstadoCatIns.idEstado"
        :set-estado="setEstado"
        :is-ciudad="true"
        :id-ciudad="objCiudadCatIns == null ? null : objCiudadCatIns.idCiudad" 
        :set-ciudad="setCiudad"
        :set-value-parametro="setValueParametro" 
        :consulta="consultaInformacionTerritorial" 
        :vista-previa="vistaPrevia"
        :textoCatalogoDistribucionTerritorial="objEncuesta.textoCatalogoDistribucionTerritorial">
      </cat-dist-encuesta>


      <secciones-encuesta :lst-secciones="lstSecciones" :set-respuesta="setRespuesta" :remove-pregunta-dep="removePreguntaDep" :open-dialog-enviar-encuesta="openDialogEnviarEncuesta" :set-value-parametro="setValueParametro" :consulta="consulta" :vista-previa="vistaPrevia" :encuesta-autenticada="objEncuesta.conAutenticacion" :mostrarPOrdenamiento="respuestaOrdenamineto"></secciones-encuesta>

<v-card-subtitle><div v-html="objEncuesta.pieEncuesta"/></v-card-subtitle>
      <v-dialog
        key="dialogEnviarEncuesta"
        v-model="dialogEnviarEncuesta"
        max-width="450"
        persistent
      >
        <v-form 
          ref="formEnviarCorreo" 
          v-model="validFormEnviarCorreo" 
          :lazy-validation="lazyFormEnviarCorreo"
        >
          <v-card>
            <v-card-title class="headline" color="primary">
              <v-icon class="pr-1">mdi-content-save</v-icon>
              Guardar Encuesta
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="checkboxEnviarCorreo"
                    label="Deseo recibir por correo  la liga para ver el resultado de mi encuesta."
                  ></v-checkbox>
                </v-col> 
                <v-col cols="12">
                  <label>Correo electrónico</label>
                  <v-text-field
                    v-model="correoEnviarEncuesta"
                    solo
                    prepend-inner-icon="mail"
                    :rules="checkboxEnviarCorreo == true ? emailRules : []"
                    :disabled="checkboxEnviarCorreo == false"
                    :required="checkboxEnviarCorreo == true"                  
                  ></v-text-field>
                </v-col>  
              </v-row>       
            </v-card-text>  

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :loading="loadingGuardarEncuesta"                 
                color="normal"                    
                @click="dialogEnviarEncuesta = false"
              >
                cancelar
              </v-btn>
              <v-btn
                :loading="loadingGuardarEncuesta"                 
                color="success"
                @click="guardarEncuesta"
              >
                Finalizar Encuesta
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-card>
    <v-snackbar
        key="snackbar_encuesta"
        v-model="snackbar"
        :bottom="true"
        :multi-line="true"
        :color="snackbarColor"
      >
        {{ snackbarTexto }}
        <v-btn dark text @click="snackbar = false; if (snackbarColor == 'success') { closeDialog() }">
          Cerrar
        </v-btn>
      </v-snackbar>  
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { postEiResultadoEncuesta } from "@/api";
import jwt_decode from "jwt-decode";

export default {
  name: 'Encuesta',
  components: {
    CatInsEncuesta: () => import('../encuesta/CatInsEncuesta'),
    CatDistEncuesta:()=>import('../encuesta/catDistEncuesta'),    
    SeccionesEncuesta: () => import('../encuesta/SeccionesEncuesta'),    
  },
  props: {
    objEncuesta: {
      type: Object,
      required: true,
    },
    imgPortada: {
      type: String,
      default: null,
    },
    parametros: {
      type: String,
      required: true
    },
    objResultadoEncuesta: {
      type: Object,
      default: null
    },
    vistaPrevia: {
      type: Boolean, 
      default: false
    },
    tokenResultado: {
      type: String,
      required: true,
      default: ''
    },
  },
  
  data: () => ({
    snackbar: false,
    snackbarColor: '',
    snackbarTexto: '',
    
    lstSecciones: [],
    objEncuestaRespuestas: null,
    objArregloRespuestas: {},

    dialogEnviarEncuesta: false,
    loadingGuardarEncuesta: false,
    correoEnviarEncuesta: '',
    emailRules:[v=>!!v || 'Campo obligatorio'],
    checkboxEnviarCorreo: false,

    validFormEnviarCorreo: false,
    lazyFormEnviarCorreo: false,

    encuestaGuardada: false,
////////////////////////////////////////7
    objCampusCatIns: null,
    objDivisionCatIns: null,
    objDepartamentoCatIns: null,
//////////////////////////////////////////
    objEstadoCatIns: null,
    objCiudadCatIns: null,
    snackbar: false,
    snackbarTexto: "",
    snackbarColor: "",
    objParametros: {},
    consulta: false,
    consultaInformacionTerritorial:false,
    respuestaOrdenamineto:false,
  }),
  computed: {
    ...mapGetters('oidc', ['oidcUser']),

/*     lstSecciones: function () {
      if(this.objEncuesta == undefined){
        return []
      }
      else{
        return JSON.parse(this.objEncuesta.jsonDato).ARREGLO_SECCIONES
      }      
    } */
  },
  watch: {
    correoEnviarEncuesta: function (mail) {
      if (mail !== '') {
        this.emailRules = [ v => (v.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) || 'Por favor escriba un correo electrónico válido']
      } else if (mail === '') {
        this.emailRules = [v=>!!v || 'Campo obligatorio']
      }
    },

  },
  async created() {
    if(this.objEncuesta != undefined){
      if(this.objResultadoEncuesta != null){
       
      this.lstSecciones = JSON.parse(this.objResultadoEncuesta.jsonEncuesta);
          this.consulta=true;
        if(this.objResultadoEncuesta.idCampus != null){
          this.objCampusCatIns = {id: this.objResultadoEncuesta.idCampus.toString().trim(), descripcion: this.objResultadoEncuesta.campus };

          if(this.objResultadoEncuesta.idDivision != null){
            this.objDivisionCatIns = {id: this.objResultadoEncuesta.idDivision.toString().trim(), descripcion: this.objResultadoEncuesta.division };

            if(this.objResultadoEncuesta.idDepPlanUnidad != null){
              this.objDepartamentoCatIns = {id: this.objResultadoEncuesta.idDepPlanUnidad.toString().trim(), descripcion: this.objResultadoEncuesta.depPlanUnidad };              
            } 
         
          } 
        }

        if(this.objResultadoEncuesta.idEstado != null){
          this.consultaInformacionTerritorial = true;
            this.objEstadoCatIns = {idEstado: this.objResultadoEncuesta.idEstado, estado: this.objResultadoEncuesta.estado };
          if(this.objResultadoEncuesta.idCiudad != null){
            this.objCiudadCatIns = {idCiudad: this.objResultadoEncuesta.idCiudad, ciudad: this.objResultadoEncuesta.ciudad };
          }   
        }
      }
      else{
        if(this.objEncuesta.jsonDato!=undefined){
          this.lstSecciones = JSON.parse(this.objEncuesta.jsonDato).ARREGLO_SECCIONES
        }
      }
    }

    if(this.parametros != ''){
      this.objParametros = jwt_decode(this.parametros);
    }
  },
  methods: {
    convertirTexto(item) {
    return item.replace(/(?:\r\n|\r|\n)/g, '<br>')
    //return item.replace(' ', '&nbsp;', '\n').replace('\n', '<br>', '\n');
  },
    setRespuesta(idSeccion, idPregunta, idRespuesta, respuesta, valorNum, capturaLibre){
     
      var self = this;



/* Llenar respuesta objEncuestaRespuestas */
      if(self.objEncuestaRespuestas == null){
        self.objEncuestaRespuestas = JSON.parse(this.objEncuesta.jsonDato).ARREGLO_SECCIONES;
      }

      var seccion = self.objEncuestaRespuestas.filter(n=>n.SECCION.ID_SECCION == idSeccion)[0];

      if(seccion != undefined){



        var pregunta = seccion.ARREGLO_PREGUNTA.filter(n=>n.PREGUNTA.ID_PREGUNTA == idPregunta)[0];

        if(pregunta != undefined){
          switch(pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA){
            case 1:
            case 2:
            case 5:
            case 6:
              pregunta.PREGUNTA.RESPUESTA_PREGUNTA = respuesta;
              break;
            case 3:
    console.log("Opción única " +idRespuesta+"res" + respuesta)
              //VALIDAR SI TIENE PREGUNTAS DE ORDENAMINETO DEPENDIENTES
    /* */
    self.respuestaOrdenamineto=false;
    var preguntaDependienteOrdenamineto=seccion.ARREGLO_PREGUNTA.filter(n=>n.PREGUNTA.ID_PREGUNTA_DEPENDIENTE&&n.PREGUNTA.ID_CAT_TIPO_PREGUNTA==7&&n.PREGUNTA.ID_CAT_RESPUESTA_DEPENDIENTE==idRespuesta);
       
       if(preguntaDependienteOrdenamineto.length>0){
       self.respuestaOrdenamineto=true;
       }
       else{
        self.respuestaOrdenamineto=false;
       }
       
    
    pregunta.ARREGLO_RESPUESTA.forEach(function(item){
                if(item.RESPUESTA.ID_CAT_RESPUESTA == idRespuesta){
                  item.RESPUESTA.SELECCIONADA = true;
                
                
                }
                else{
                  item.RESPUESTA.SELECCIONADA = false;
                
                
                }
              })
            
            
            
            if(self.objEncuestaRespuestas){

              pregunta.PREGUNTA.RESPUESTA_PREGUNTA = capturaLibre ? respuesta : "";
            }
            
            break;
            case 4:
    
    if(idRespuesta != null){
                pregunta.ARREGLO_RESPUESTA.forEach(function(item){

                  var respIsInArray = idRespuesta.filter(n=>n.RESPUESTA.ID_CAT_RESPUESTA == item.RESPUESTA.ID_CAT_RESPUESTA)[0];
                  
                  if(respIsInArray != undefined){
                    item.RESPUESTA.SELECCIONADA = true;
                  }
                  else{
                    item.RESPUESTA.SELECCIONADA = false;
                  }
                })
                pregunta.PREGUNTA.RESPUESTA_PREGUNTA = "";
              }
              else{
                pregunta.PREGUNTA.RESPUESTA_PREGUNTA = respuesta;
              }

              //VALIDAR SI TIENE PREGUNTAS DE ORDENAMINETO DEPENDIENTES
    //var preguntaDependienteOrdenamineto=seccion.ARREGLO_PREGUNTA.filter(n=>n.PREGUNTA.ID_PREGUNTA_DEPENDIENTE==idPreguntaM&&n.PREGUNTA.ID_CAT_TIPO_PREGUNTA==7);
    //console.log("dependiente")
    //console.log(preguntaDependienteOrdenamineto)
            
            
            
            
            
            break;
            case 7:
              if(idRespuesta == null){
                //pregunta.PREGUNTA.RESPUESTA_PREGUNTA = "";

                //Recorrer la respuesta recibida para actualizar los valores de respuestas
                respuesta.forEach((resp) => {

                  var respuestaOrig = pregunta.ARREGLO_RESPUESTA.filter(n=>n.RESPUESTA.ID_CAT_RESPUESTA == resp.RESPUESTA.ID_CAT_RESPUESTA)[0];

                  if(respuestaOrig != undefined){
                    respuestaOrig.RESPUESTA.VALOR_RESPUESTA = resp.RESPUESTA.VALOR_RESPUESTA;
                  }
                  
                });

                pregunta.ARREGLO_RESPUESTA = pregunta.ARREGLO_RESPUESTA.sort((a, b) => a.RESPUESTA.VALOR_RESPUESTA-b.RESPUESTA.VALOR_RESPUESTA);

              }
              else{
                pregunta.PREGUNTA.RESPUESTA_PREGUNTA = respuesta;
              }
              break;

          }


         
          /* Llenar respuesta en objArregloRespuestas */
          // El tipo de pregunta no es parámetro
          if(pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA != 6){
            if(self.objArregloRespuestas.ARREGLO_PREGUNTAS == undefined){
              self.objArregloRespuestas.ARREGLO_PREGUNTAS = [];
            }

            //El tipo de pregunta no es de opción multiple
            if(pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA != 4 && pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA != 7){

              var preguntaArrPreg = self.objArregloRespuestas.ARREGLO_PREGUNTAS.filter(n=>n.ID_SECCION == idSeccion && n.ID_PREGUNTA == idPregunta)[0];

              if(preguntaArrPreg == undefined){
                var obj = {
                  ID_SECCION: idSeccion,
                  NOMBRE_SECCION: seccion.SECCION.NOMBRE_SECCION,
                  TOTAL_SECCION: 0, //PENDIENTE
                  NOMBRE_PREGUNTA: pregunta.PREGUNTA.NOMBRE_PREGUNTA,
                  ID_CAT_TIPO_PREGUNTA: pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA,
                  TOTAL_PREGUNTA: 0, //PENDIENTE
                  PROMEDIABLE: pregunta.PREGUNTA.PROMEDIABLE,
                  ID_CAT_RESPUESTA: idRespuesta,
                  VALOR_TEXTO: respuesta,
                  ID_PREGUNTA: idPregunta,
                  VALOR_NUM: valorNum,
                  CAPTURA_LIBRE: capturaLibre,
                  ID_CAT_PARAMETRO: 0,
                  NOMBRE_PARAMETRO: ''
                }

                //Array.prototype.push.apply(self.objArregloRespuestas.ARREGLO_PREGUNTAS, obj);

                self.objArregloRespuestas.ARREGLO_PREGUNTAS.push(obj);
              }
              else{
               
                preguntaArrPreg.ID_CAT_RESPUESTA = idRespuesta;
                preguntaArrPreg.VALOR_TEXTO = respuesta;
                preguntaArrPreg.VALOR_NUM = valorNum;
                preguntaArrPreg.CAPTURA_LIBRE = capturaLibre;
                var lstPreguntasDependientes=[];
                
              self.eliminarPreguntasDependientes(idPregunta, seccion,lstPreguntasDependientes)
              
        self.respuestaOrdenamineto=false;
    var preguntaDependienteOrdenamineto=seccion.ARREGLO_PREGUNTA.filter(n=>n.PREGUNTA.ID_PREGUNTA_DEPENDIENTE&&n.PREGUNTA.ID_CAT_TIPO_PREGUNTA==7&&n.PREGUNTA.ID_CAT_RESPUESTA_DEPENDIENTE==idRespuesta);
       console.log(seccion)
       if(preguntaDependienteOrdenamineto.length>0){
       self.respuestaOrdenamineto=true;
       }
       else{
        self.respuestaOrdenamineto=false;
       }
       
          
              }
        
       
       //console.log("ARREGLO PREGUNTAS");
        //console.log(self.objEncuestaRespuestas)


}else if (pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 4){//Para los tipos de opción múltiple
              if(idRespuesta != null){//Cuando se modificaron las opciones seleccionadas

                //Se eliminan las respuestas guardadas anteriormente para esta pregunta
                self.objArregloRespuestas.ARREGLO_PREGUNTAS = self.objArregloRespuestas.ARREGLO_PREGUNTAS.filter(function(item) {
                    return item.ID_PREGUNTA !== idPregunta
                })

                idRespuesta.forEach(function(item){
                  
                  var obj = {
                    ID_SECCION: idSeccion,
                    NOMBRE_SECCION: seccion.SECCION.NOMBRE_SECCION,
                    TOTAL_SECCION: 0, //PENDIENTE
                    NOMBRE_PREGUNTA: pregunta.PREGUNTA.NOMBRE_PREGUNTA,
                    ID_CAT_TIPO_PREGUNTA: pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA,
                    TOTAL_PREGUNTA: 0, //PENDIENTE
                    PROMEDIABLE: pregunta.PREGUNTA.PROMEDIABLE,
                    ID_CAT_RESPUESTA: item.RESPUESTA.ID_CAT_RESPUESTA,
                    VALOR_TEXTO: item.RESPUESTA.CAPTURA_LIBRE ? "" : item.RESPUESTA.RESPUESTA,
                    ID_PREGUNTA: idPregunta,
                    VALOR_NUM: item.RESPUESTA.VALOR_RESPUESTA,
                    CAPTURA_LIBRE: item.RESPUESTA.CAPTURA_LIBRE,
                    ID_CAT_PARAMETRO: 0,
                    NOMBRE_PARAMETRO: ''
                  }
                  //Array.prototype.push.apply(self.objArregloRespuestas.ARREGLO_PREGUNTAS, obj);
                  self.objArregloRespuestas.ARREGLO_PREGUNTAS.push(obj);
                })
              }
              else{//Cuando solo se actualiza el texto libre
                var preg = self.objArregloRespuestas.ARREGLO_PREGUNTAS.filter(n=>n.ID_SECCION == idSeccion && n.ID_PREGUNTA == idPregunta && n.CAPTURA_LIBRE == true)[0];                
                
                if(preg != undefined){
                  preg.VALOR_TEXTO = respuesta;
                }

              }
            }
            else if (pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA == 7){//Para los tipos de ordenamiento
              if(idRespuesta == null){//Cuando se ordenaron las respuestas

                //Se eliminan las respuestas guardadas anteriormente para esta pregunta
                self.objArregloRespuestas.ARREGLO_PREGUNTAS = self.objArregloRespuestas.ARREGLO_PREGUNTAS.filter(function(item) {
                    return item.ID_PREGUNTA !== idPregunta
                })

                respuesta.forEach(function(item){
                  
                  var obj = {
                    ID_SECCION: idSeccion,
                    NOMBRE_SECCION: seccion.SECCION.NOMBRE_SECCION,
                    TOTAL_SECCION: 0, //PENDIENTE
                    NOMBRE_PREGUNTA: pregunta.PREGUNTA.NOMBRE_PREGUNTA,
                    ID_CAT_TIPO_PREGUNTA: pregunta.PREGUNTA.ID_CAT_TIPO_PREGUNTA,
                    TOTAL_PREGUNTA: 0, //PENDIENTE
                    PROMEDIABLE: pregunta.PREGUNTA.PROMEDIABLE,
                    ID_CAT_RESPUESTA: item.RESPUESTA.ID_CAT_RESPUESTA,
                    VALOR_TEXTO: item.RESPUESTA.CAPTURA_LIBRE ? pregunta.PREGUNTA.RESPUESTA_PREGUNTA : item.RESPUESTA.RESPUESTA,
                    ID_PREGUNTA: idPregunta,
                    VALOR_NUM: item.RESPUESTA.VALOR_RESPUESTA,
                    CAPTURA_LIBRE: item.RESPUESTA.CAPTURA_LIBRE,
                    ID_CAT_PARAMETRO: 0,
                    NOMBRE_PARAMETRO: ''
                  }

                  //Array.prototype.push.apply(self.objArregloRespuestas.ARREGLO_PREGUNTAS, obj);

                  self.objArregloRespuestas.ARREGLO_PREGUNTAS.push(obj);

                })

              }
              else{//Cuando solo se actualiza el texto libre
                var preg = self.objArregloRespuestas.ARREGLO_PREGUNTAS.filter(n=>n.ID_SECCION == idSeccion && n.ID_PREGUNTA == idPregunta && n.CAPTURA_LIBRE == true)[0];                
                
                if(preg != undefined){
                  preg.VALOR_TEXTO = respuesta;
                }

              }
            }
          }
          else{            
            self.objArregloRespuestas[pregunta.PREGUNTA.NOMBRE_PARAMETRO] = respuesta;

            if(pregunta.PREGUNTA.NOMBRE_PARAMETRO == "CORREO"){
              self.correoEnviarEncuesta = respuesta;
            }
          }
       // console.log(self.objEncuesta);
          //alert("respuesta: " + respuesta)
          console.log("AAREGLO RESPUESTAS FINAL")
          console.log(self.objArregloRespuestas.ARREGLO_PREGUNTAS)
          console.log("Arreglo preguntas respuestas")
          console.log(self.objEncuestaRespuestas)
        }
        else{
          self.snackbarColor = "error";
          self.snackbarTexto = "No se encontró la pregunta " + idPregunta + " de la sección " + idSeccion;
          self.snackbar = true;
        }
      }
      else{
        self.snackbarColor = "error";
        self.snackbarTexto = "No se encontró la sección " + idSeccion;
        self.snackbar = true;
      }
    },
    removePreguntaDep(idPregunta){
      //console.log("Pregunta eliminada")
    },
    openDialogEnviarEncuesta(){
      this.dialogEnviarEncuesta = true;
    },
    setValueParametro(objPreg, idSeccion){
      var objSeccion = this.lstSecciones.filter(n=> n.SECCION.ID_SECCION == idSeccion)[0];

      if(objSeccion != undefined){
        var preg = objSeccion.ARREGLO_PREGUNTA.filter(n=>n.PREGUNTA.ID_PREGUNTA == objPreg.PREGUNTA.ID_PREGUNTA)[0];

        if(preg != undefined){
          var valParam = '';
          
          if(this.objEncuesta.conAutenticacion == true){
            switch(preg.PREGUNTA.NOMBRE_PARAMETRO){
              case 'NUA':
                valParam = this.oidcUser.NUA;
                break;
              case 'NUE':
                valParam = this.oidcUser.Id_Empleado;
                break;
              case 'ID_INTRAUG':
                valParam = this.oidcUser.Id_Intranet;
                break;
              case 'CORREO':
                valParam = this.oidcUser.email;
                break;      
              case 'NOMBRE':
                valParam = JSON.parse(this.oidcUser.profile).Nombre;
                break;              
              default:
                valParam = '';
                break;
            }


          }
          else{
            valParam = this.objParametros[preg.PREGUNTA.NOMBRE_PARAMETRO];
          }
          
          preg.PREGUNTA.RESPUESTA_PREGUNTA = valParam == undefined ? 'paramUnd' : valParam;

        }
      }

    },
    async guardarEncuesta(){


if(this.$refs.formEnviarCorreo.validate()) {
        var self = this;

        self.loadingGuardarEncuesta = true;
        self.snackbar = false;
        self.snackbarTexto = "";
        self.snackbarColor = "";
         console.log("ARREGLO RESPUESTAS FINAL GUARDADO")
          console.log(self.objArregloRespuestas.ARREGLO_PREGUNTAS)
        console.log(self.objArregloRespuestas)
try {

          var pregPromediables = self.objArregloRespuestas.ARREGLO_PREGUNTAS == undefined ? [] : self.objArregloRespuestas.ARREGLO_PREGUNTAS.filter(n=>n.PROMEDIABLE == true);

          var numPregProm = pregPromediables.length;
          var sumaPregProm = pregPromediables.reduce((a, b) => +a + +b.VALOR_NUM, 0);
          var promPregProm = numPregProm == 0 ? 0 : sumaPregProm / numPregProm;
          var resPorc = promPregProm * 100;

          var objResultado = {};

          var newNUA = self.objArregloRespuestas.NUA == undefined ? null : self.objArregloRespuestas.NUA;
          var newNUE = self.objArregloRespuestas.NUE == undefined ? null : self.objArregloRespuestas.NUE;
          var newNombre = self.objArregloRespuestas.NOMBRE == undefined ? null : self.objArregloRespuestas.NOMBRE;
          var newCorreo = self.objArregloRespuestas.CORREO == undefined ? null : self.objArregloRespuestas.CORREO;


          if(self.tokenResultado == ''){
            objResultado = {
              idEncuesta: self.objEncuesta.idEncuesta,
              promedioPreguntasPromedibles: promPregProm,
              jsonEncuesta: JSON.stringify(self.objEncuestaRespuestas),
              jsonResultado: JSON.stringify(self.objArregloRespuestas),
              numPreguntasPromediables: numPregProm,
              resultadoPorcentaje: resPorc,
              sumaPreguntasPromedibles: sumaPregProm,
              solicitoRespuestas: self.checkboxEnviarCorreo,
              correoRecibeRespuestas: self.correoEnviarEncuesta,
              nua: newNUA,
              nue: newNUE,
              nombre: newNombre,
              correo: newCorreo,
              idCampus: this.objCampusCatIns == null ? null : this.objCampusCatIns.id,
              campus: this.objCampusCatIns == null ? null : this.objCampusCatIns.descripcion,
              idDivision: this.objDivisionCatIns == null ? null : this.objDivisionCatIns.id,
              division: this.objDivisionCatIns == null ? null : this.objDivisionCatIns.descripcion,
              idDepPlanUnidad: this.objDepartamentoCatIns == null ? null : this.objDepartamentoCatIns.id,
              depPlanUnidad: this.objDepartamentoCatIns == null ? null : this.objDepartamentoCatIns.descripcion,
              idEstado: this.objEstadoCatIns == null ? null : this.objEstadoCatIns.idEstado,
              estado: this.objEstadoCatIns == null ? null : this.objEstadoCatIns.estado,
              idCiudad: this.objCiudadCatIns == null ? null : this.objCiudadCatIns.idCiudad,
              ciudad: this.objCiudadCatIns == null ? null : this.objCiudadCatIns.ciudad
            };
          }
          else{
            objResultado = {
              idEncuesta: self.objEncuesta.idEncuesta,
              promedioPreguntasPromedibles: promPregProm,
              jsonEncuesta: JSON.stringify(self.objEncuestaRespuestas),
              jsonResultado: JSON.stringify(self.objArregloRespuestas),
              numPreguntasPromediables: numPregProm,
              resultadoPorcentaje: resPorc,
              sumaPreguntasPromedibles: sumaPregProm,
              solicitoRespuestas: self.checkboxEnviarCorreo,
              correoRecibeRespuestas: self.correoEnviarEncuesta,
              tokenResultado: self.tokenResultado,
              nua: newNUA,
              nue: newNUE,
              nombre: newNombre,
              correo: newCorreo,
              idCampus: this.objCampusCatIns == null ? null : this.objCampusCatIns.id,
              campus: this.objCampusCatIns == null ? null : this.objCampusCatIns.descripcion,
              idDivision: this.objDivisionCatIns == null ? null : this.objDivisionCatIns.id,
              division: this.objDivisionCatIns == null ? null : this.objDivisionCatIns.descripcion,
              idDepPlanUnidad: this.objDepartamentoCatIns == null ? null : this.objDepartamentoCatIns.id,
              depPlanUnidad: this.objDepartamentoCatIns == null ? null : this.objDepartamentoCatIns.descripcion,
              idEstado: this.objEstadoCatIns == null ? null : this.objEstadoCatIns.idEstado,
              estado: this.objEstadoCatIns == null ? null : this.objEstadoCatIns.estado,
              idCiudad: this.objCiudadCatIns == null ? null : this.objCiudadCatIns.idCiudad,
              ciudad: this.objCiudadCatIns == null ? null : this.objCiudadCatIns.ciudad
            };
          }

          let response  = await postEiResultadoEncuesta(objResultado);      


          if (response.status === 200) {
            if (response.data.flag === true) {
                if (response.data.message === "True") {
                  self.encuestaGuardada = true;
                  window.scrollTo(0,0);
                }
            } else {
              self.snackbarTexto = "Encuesta: " + response.data.message;
              self.snackbarColor = "error";
              self.snackbar = true;
            }
          } else {
              self.snackbarTexto = "Encuesta: Error de red";
              self.snackbarColor = "error";
              self.snackbar = true;
          }
          self.loadingGuardarEncuesta = false;
        } catch (e) {
            self.loadingGuardarEncuesta = false;
            self.snackbarTexto = "Encuesta: " + e;
            self.snackbarColor = "error";
            self.snackbar = true;
        }
      }
    },
    setCampus(objCampus){
      this.objDepartamentoCatIns = null;
      this.objDivisionCatIns = null;
      this.objCampusCatIns = objCampus;
    },
    setDivision(objDivision){
      this.objDepartamentoCatIns = null;
      this.objDivisionCatIns = objDivision;
    },
    setDepartamento(objDepartamento){
      this.objDepartamentoCatIns = objDepartamento;
    },
    setEstado(objEstado){
      this.objCiudadCatIns = null;
      this.objEstadoCatIns = objEstado;
    },
    setCiudad(objCiudad){
      this.objCiudadCatIns = objCiudad;
    },

    eliminarPreguntasDependientes( idPreguntaM, seccion, dependientes){
    var self = this;
    var preguntaDependiente=seccion.ARREGLO_PREGUNTA.filter(n=>n.PREGUNTA.ID_PREGUNTA_DEPENDIENTE==idPreguntaM);
    if(preguntaDependiente!=null&&preguntaDependiente!=undefined&&preguntaDependiente!=""){
          preguntaDependiente.forEach(preguntaDep => {
         var respEncontrada=self.objArregloRespuestas.ARREGLO_PREGUNTAS.filter((e)=>e.ID_PREGUNTA===preguntaDep.PREGUNTA.ID_PREGUNTA);
            //if(respEncontrada!=null&&respEncontrada!=undefined){
              respEncontrada.forEach(rEncontrada=>{

              
                const index =self.objArregloRespuestas.ARREGLO_PREGUNTAS.indexOf(rEncontrada);
                  self.objArregloRespuestas.ARREGLO_PREGUNTAS.splice(index,1);      
                  
                 // var respuestaArrayP=self.objEncuestaRespuestas.ARREGLO_PREGUNTA.find((e)=>e.ID_PREGUNTA===preguntaDep.PREGUNTA.ID_PREGUNTA)
                  self.objEncuestaRespuestas.forEach(preg => {
                   // console.log("Veces que entró")
                 // console.log(preg.ARREGLO_PREGUNTA);
                  preg.ARREGLO_PREGUNTA.forEach(ap=>{
                    //console.log(ap.PREGUNTA.ID_PREGUNTA)
                    if(ap.PREGUNTA.ID_PREGUNTA==preguntaDep.PREGUNTA.ID_PREGUNTA){
                      if(ap.ARREGLO_RESPUESTA!=null){
                        //Marcar seleccionado false a las respuestas de prreguntas dependientes de objEncuestaRespuesta 
                          ap.ARREGLO_RESPUESTA.forEach(res=>{
                           res.RESPUESTA.SELECCIONADA=false;
                      });
                      }
                      else{
                        if(ap.PREGUNTA.ID_CAT_TIPO_PREGUNTA==1){
                          //Limbiar el texto de la pregunta dependiente tipo texto
                          
                          ap.PREGUNTA.RESPUESTA_PREGUNTA=null;
                        }
                      }
                      
                    }
                  });
                  });
                  
                  });
                
                 

            
            dependientes.push(preguntaDep)
            self.eliminarPreguntasDependientes(preguntaDep.PREGUNTA.ID_PREGUNTA, seccion, dependientes)
        });
  //    }
    }   
  }
 },
 
}

</script>
